module.exports = __webpack_public_path__ + "static/media/atharva.6f3c80e1.jpg";